import {

    FIND_MATCHES_FAILED,
    FIND_MATCHES_SUCCESS,
    FIND_MATCHES_START,
    FIND_LISTING_MATCHES_START,
    FIND_LISTING_MATCHES_SUCCESS,
    FIND_LISTING_MATCHES_FAILED

} from "../store/types";

const INITIAL_STATE = {
    MatchedProperties: [],
    MatchedEnquiries: [],
    MatchedActiveEnquiries: [],
    MatchedArchivedEnquiries: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const matchingreducer = (state = INITIAL_STATE, action) => {
    // console.log('action.type', action.type)
    switch (action.type) {
        case FIND_MATCHES_START:
            return {
                ...state,
                MatchedProperties: [],
                loading: true,
            };
        case FIND_MATCHES_SUCCESS:
            return {
                ...state,
                MatchedProperties: action.payload,
                loading: false,
            };
        case FIND_MATCHES_FAILED:
            return {
                ...state,
                error: {
                    flag: true,
                    msg: action.payload
                },
            };
        case FIND_LISTING_MATCHES_START:
            return {
                ...state,
                MatchedEnquiries: [],
                MatchedActiveEnquiries: [],
                MatchedArchivedEnquiries: [],
                loading: true,
            }
        case FIND_LISTING_MATCHES_SUCCESS:
            return {
                ...state,
                MatchedEnquiries: action.payload,
                MatchedActiveEnquiries: action.payload.activeMatchedData,
                MatchedArchivedEnquiries: action.payload.archivedMatchedData,
                loading: false,
            };
        case FIND_LISTING_MATCHES_FAILED:
            return {
                ...state,
                error: {
                    flag: true,
                    msg: action.payload
                },
            };

        default:
            return state;
    }
};